/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './duration.reducer';

export const DurationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const durationEntity = useAppSelector(state => state.duration.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="durationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.duration.detail.title">Duration</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.duration.id">Id</Translate>
            </span>
          </dt>
          <dd>{durationEntity.id}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.duration.description">Description</Translate>
            </span>
          </dt>
          <dd>{durationEntity.description}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.duration.active">Active</Translate>
            </span>
          </dt>
          <dd>{durationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.duration.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{durationEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.duration.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{durationEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.duration.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{durationEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.duration.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{durationEntity.cursor}</dd>
        </dl>
        <Button tag={Link} to="/duration" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/duration/${durationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DurationDetail;
